import { render, staticRenderFns } from "./ManagementFeeList.vue?vue&type=template&id=af5c2db2&scoped=true"
import script from "./ManagementFeeList.vue?vue&type=script&lang=js"
export * from "./ManagementFeeList.vue?vue&type=script&lang=js"
import style0 from "./ManagementFeeList.vue?vue&type=style&index=0&id=af5c2db2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5c2db2",
  null
  
)

export default component.exports